module.exports = {
  ...require('Auth/Resources/assets/js/store/actions'),
  ...require('User/Resources/assets/js/store/actions'),
  ...require('Union/Resources/assets/js/store/actions'),
  ...require('Discussion/Resources/assets/js/store/actions'),
  ...require('Document/Resources/assets/js/store/actions'),
  ...require('Membership/Resources/assets/js/store/actions'),
  ...require('ActivityFeed/Resources/assets/js/store/actions'),
  ...require('Notification/Resources/assets/js/store/actions'),
  ...require('Communication/Resources/assets/js/store/actions'),
  ...require('Resource/Resources/assets/js/store/actions'),
  ...require('Calendar/Resources/assets/js/store/actions'),
  ...require('FormBuilder/Resources/assets/js/store/actions'),
  ...require('Payments/Resources/assets/js/store/actions'),
  ...require('Export/Resources/assets/js/store/actions'),
  ...require('ManagedPage/Resources/assets/js/store/actions'),
}